/* eslint-disable @typescript-eslint/no-unused-vars */
import SignInForm from "components/modules/auth/SignInForm";
import AuthCardLayout from "layouts/AuthCardLayout";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const navigate = useNavigate();
  const [cookie] = useCookies(["isLoggedInKIQ"]);
  const [hasCheckedAuth, setHasCheckedAuth] = useState(false);

  useEffect(() => {
    // Add a small delay to prevent rapid redirect loops
    const checkAuth = setTimeout(() => {
      const hasToken = localStorage.getItem("auth_token");
      
      console.log("🔐 [SIGNIN] Auth check:", {
        cookieAuth: cookie.isLoggedInKIQ,
        hasToken: !!hasToken
      });
      
      if (cookie.isLoggedInKIQ || hasToken) {
        console.log("🔄 [SIGNIN] User already authenticated, redirecting to dashboard");
        navigate("/dashboard");
      }
      setHasCheckedAuth(true);
    }, 100); // Small delay to prevent race conditions

    return () => clearTimeout(checkAuth);
  }, [cookie.isLoggedInKIQ, navigate]);

  return (
    <AuthCardLayout className="pb-md-7">
      <SignInForm layout="card" />
    </AuthCardLayout>
  );
};

export default SignIn;
